module.exports = __webpack_public_path__ + "img/10979904_L.3f7b3e61.png";